<template>
<td colspan="1">

  <button class="k-button k-primary k-mr-1" v-for="(leta,shema) in sheme.reduce(
  (rv,e)=>{ 
    (rv[e.shema]=rv[e.shema]||[]).push(e.sezona);
     return rv;},{})">
     {{shema}}
    
    </button>

</td>
</template>
<script>
export default {
  // <span class="k-badge-solid k-badge-primary k-badge-circle k-badge">{{leta.length}}</span>
  props: {
   sheme:Array
  },
  computed: {
    icon(){
      return this.checked?"check":"times";
    },
    spanClass() {
      return {
       'k-badge':true,'k-badge-solid':true,'k-badge-md':true,'k-badge-pill':true,
                "action_error":!this.checked,"action_success":this.checked
        
      };
    }
  }
};
</script>